<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="">
            <div class="flex mt-4 mb-2">
                <LoaderButton title="Enregistrer" @ok="handleUpdateBienSettings" ref="btnUpdateSettings"></LoaderButton>
            </div>
            <hr class="border-gray-200 dark:border-gray-800">
            <SwitchForm class="mt-3" v-model='bien.auto_loyer' labelRight="Loyer automatique" id='autoLoyer'/>
            <div 
                class="flex flex-wrap items-center mt-2"
                :class="bien.auto_loyer_at ? 'text-indigo-500' : formError.includes('autoLoyerError') ? 'text-red-500' : 'text-yellow-500'"
                v-if="bien.auto_loyer"
            >
                <p>Créer un paiement automatique tous les </p>
                <Multiselect
                    v-model='bien.auto_loyer_at'
                    id='autoLoyerAt'
                    :options="autoLoyerAtOptions"
                    v-bind="$multiselectBind"
                    placeholder=""
                    class="mx-3"
                    style="max-width: 5rem;"
                    selectedLabel=""
                />
                <p class="text-wrap"> de chaque mois</p>
            </div>
        </div>
        <div>
            <div v-if="bien">
                <div v-if="!bien.archived" class="mt-4 bg-yellow-100 border-l-4 p-5 border-yellow-400 font-medium dark:bg-yellow-500/10 dark:border-yellow-500/40">
                    <h4 class="text-gray-800 dark:text-gray-100">Archiver ce bien</h4>
                    <p class="text-sm text-gray-600 dark:text-gray-400">Cette action retirera le bien de votre liste, vous pourrez toujours y accéder pour consulter les informations.</p>
                    <button class="btn-warning mt-2" @click.prevent="confirmArchiveBien()">
                        Archiver
                    </button>
                </div>
                <div v-else class="mt-4 bg-blue-100 border-l-4 p-5 border-blue-400 font-medium dark:bg-blue-500/10 dark:border-blue-500/40">
                    <h4 class="text-gray-800 dark:text-gray-100">Désarchiver ce bien</h4>
                    <p class="text-sm text-gray-600 dark:text-gray-400">Cette action retirera le bien des archives.</p>
                    <button class="btn-info mt-2" @click.prevent="confirmUnarchiveBien()">
                        Désarchiver
                    </button>
                </div>
            </div>
            <SpinnerLoader v-else class="mt-5"></SpinnerLoader>
            <div class="mt-4 bg-red-100 border-l-4 p-5 border-red-400 font-medium dark:bg-red-500/10 dark:border-red-500/40">
                <h4 class="text-gray-800 dark:text-gray-100">Supprimer ce bien</h4>
                <p class="text-sm text-gray-400 dark:text-gray-400">Cette action supprimera complètement le bien. Elle est irréversible.</p>
                <button class="btn-danger mt-2" @click.prevent="confirmRemoveBien()">
                    Supprimer
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import LoaderButton from './../../components/form/LoaderButton';
import SwitchForm from './../../components/form/SwitchForm';
import SpinnerLoader from './../../components/loader/SpinnerLoader';
import Multiselect from 'vue-multiselect'
import { inject } from 'vue'
import { mapGetters } from "vuex";

export default {
    components: {
        SpinnerLoader,
        SwitchForm,
        Multiselect,
        LoaderButton
    },
    data() {
        return {
            bien: {
                auto_loyer: 0,
                auto_loyer_at: ''
            },
            loaded: false,
            formError: []
        }
    },
    created() {
        this.loadBien()
    },
    computed: {
        ...mapGetters({
            autoLoyerAtOptions: 'getDayOptions',
        }),
    },
    methods: {
        async loadBien() {
            const api = inject('api');

            this.loaded = false

            this.bien = await api.bien.getBien(this.$route.params.bienUuid);

            if (this.bien.auto_loyer === null) {
                this.bien.auto_loyer = 0
            }

            this.loaded = true
        },
        confirmArchiveBien() {
            this.$confirm({
                variant: 'warning',
                title: 'Archiver le bien',
                message: "Êtes-vous sûr de vouloir archiver ce bien. Cette action peut être réversible dans la section paramètre.",
                confirmText: 'Archiver',
                action: () => this.archiveBien(),
            });
        },
        confirmUnarchiveBien() {
            this.$confirm({
                variant: 'info',
                title: 'Désarchiver le bien',
                message: "Désarchiver ce bien.",
                confirmText: 'Désarchiver',
                action: () => this.unarchiveBien(),
            });
        },
        confirmRemoveBien() {
            this.$confirm({
                variant: 'danger',
                title: 'Supprimer le bien',
                message: "Vous êtes sur le point de supprimer ce bien. Cette action est irréversible, en êtes-vous sûr ?",
                confirmText: 'Supprimer',
                action: () => this.removeBien(),
            });
        },
        async archiveBien() {
            if (this.bien.archived || !this.bien.uuid) {
                return;
            }

            await this.$api.bien.archiveBien(this.bien.uuid)
            .then(() => {
                this.$toast({title: 'Succès', description: "Le bien à été archivé avec succès."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$router.push({ name: 'bien' })
        },
        async removeBien() {
            if (!this.$route.params.bienUuid) {
                return;
            }

            await this.$api.bien.removeBien(this.$route.params.bienUuid)
            .then(() => {
                this.$toast({title: 'Succès', description: "Le bien à été supprimé avec succès."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$router.push({ name: 'bien' })
        },
        async unarchiveBien() {
            if (!this.bien.archived || !this.bien.uuid) {
                return;
            }

            await this.$api.bien.unarchiveBien(this.bien.uuid)
            .then(() => {
                this.$toast({title: 'Succès', description: "Le bien à été désarchivé avec succès."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$router.push({ name: 'bien' })
        },
        async handleUpdateBienSettings() {
            if (!this.checkFieldValid()) {
                return;
            }

            this.$refs.btnUpdateSettings.activateLoader();

            await this.$api.bien.updateAutoLoyer(this.bien.uuid, {
                auto_loyer: this.bien.auto_loyer ? true : false,
                auto_loyer_at: this.bien.auto_loyer_at,
            })
            .then(() => {
                this.$toast({title: 'Succès', description: "Les paramètres du bien ont bien été enregistré."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$refs.btnUpdateSettings.deactivateLoader();
        },
        checkFieldValid() {
            this.formError = []

            if (this.bien.auto_loyer && !this.bien.auto_loyer_at) {
                this.formError.push('autoLoyerError')
            }

            return ((this.bien.auto_loyer && this.bien.auto_loyer_at) || !this.bien.auto_loyer) && this.bien.uuid
        }
    },
};
</script>